import React, { useEffect, useState } from 'react';

import BoxConteudo from '../../../../../../components/BoxConteudo';
import CustomCol from '../../../../../../components/CustomCol';
import CustomRow from '../../../../../../components/CustomRow';
import CustomSpan from '../../../../../../components/CustomSpan';
import Tabela from '../../../../../../components/Tabela';
import { useComponentesPaf } from '../../../../../../services/enum/useComponentesPaf';
import { getAllKitDeProdutoPorProdutoId } from '../../../../../../services/produtosDAF/kitProdutoService';
import {
  formatDate,
  formataNomeMeioSiglas,
} from '../../../../../../utils/functions';
import {
  headersKitsProdutos,
  valoresExibidosOffCanvasKitProdutos,
} from '../../../Kits/auxiliarKitProdutos';

interface ProdutoKitsProps {
  produtoId: number;
}

const ProdutoKits: React.FC<ProdutoKitsProps> = ({ produtoId }) => {
  const componenteAf = useComponentesPaf();
  const [dataKit, setDataKit] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!produtoId) return;

    const fetchKits = async () => {
      try {
        const kitProdutos = await getAllKitDeProdutoPorProdutoId(produtoId);
        setDataKit(kitProdutos);
      } catch (error) {
        console.error('Erro ao buscar kits do produto:', error);
        setDataKit([]);
      } finally {
        setLoading(false);
      }
    };

    fetchKits();
  }, [produtoId]);

  if (loading) {
    return (
      <BoxConteudo boxTitulo="Kits de Produtos Farmacêuticos">
        <span style={{ fontStyle: 'italic' }}>Carregando kits...</span>
      </BoxConteudo>
    );
  }

  const tableDataKitMapped = dataKit.map((item) => ({
    id: item.id,
    statusKit:
      item.statusKit === 1 ? (
        <CustomSpan texto="Ativo" />
      ) : (
        <CustomSpan texto="Inativo" />
      ),
    componenteAF:
      componenteAf.find(
        (option: any) => option.value === item.componenteAF?.toString(),
      )?.label || 'Não informado',
    nomeKit: item.nomeKit,
    produtos:
      item.produtos?.length > 0 ? (
        <ul style={{ marginBottom: '2px', paddingLeft: '20px' }}>
          {item.produtos
            .sort((a: any, b: any) =>
              a.produtoFarmaceutico.localeCompare(b.produtoFarmaceutico),
            )
            .map((produto: any, index: number) => (
              <li key={index} style={{ marginBottom: '5px' }}>
                <b>{produto.produtoFarmaceutico}</b>
                <br />
                <span>
                  Quantidade por Kit: {produto.quantidade.toLocaleString()}{' '}
                  unidades
                </span>
              </li>
            ))}
        </ul>
      ) : (
        <span style={{ fontStyle: 'italic', color: '#888' }}>
          Não informado
        </span>
      ),
  }));

  const offCanvasKit = dataKit.map((item) => ({
    id: item.id,
    dataRegistro:
      formatDate(item.dataRegistro) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioRegistro?.nomeCompleto),
    dataUltimaAtualizacao:
      formatDate(item.dataUltimaAtualizacao) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioAtualizacao?.nomeCompleto),
    dataUltimaVisualizacao:
      formatDate(item.dataUltimaVisualizacao) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioUltimaVisualizacao?.nomeCompleto),
    nEdicoes: item.nEdicoes,
    nVisualizacoes: item.nVisualizacoes,
    separadorLog: '',
    statusKit:
      item.statusKit === 1 ? (
        <CustomSpan texto="Ativo" />
      ) : (
        <CustomSpan texto="Inativo" />
      ),
    componenteAF: componenteAf[item.componenteAF]?.label || 'Não informado',
    nomeKit: item.nomeKit,
    descricao: item.descricao,
    produtos: (
      <ul>
        {item.produtos?.map((produto: any, index: number) => (
          <li key={index}>
            <b>{produto.produtoFarmaceutico}</b> –{' '}
            {produto.quantidade.toLocaleString()} unidades
          </li>
        ))}
      </ul>
    ),
    observacoes: item.observacoes,
  }));

  return (
    <BoxConteudo
      boxTitulo="Kits de Produtos Farmacêuticos"
      helpText="Mostra os Kits de Produtos Farmacêuticos que o produto faz parte."
    >
      <CustomRow>
        <CustomCol width="100%">
          {tableDataKitMapped.length > 0 ? (
            <Tabela
              headers={headersKitsProdutos}
              dataTable={tableDataKitMapped}
              displayValues={valoresExibidosOffCanvasKitProdutos}
              dataOffCanvas={offCanvasKit}
              showPagination={false}
              rowClickable={false}
              pathOffcanvas="daf/produtosdaf/kits"
            />
          ) : (
            <span
              style={{
                fontStyle: 'italic',
                color: '#464646',
                fontSize: '1rem',
              }}
            >
              Produto não vinculado a nenhum Kit de Produtos.
            </span>
          )}
        </CustomCol>
      </CustomRow>
    </BoxConteudo>
  );
};

export default ProdutoKits;
